module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-BookItalic.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-BookItalic.woff
 ** module id = 1106
 ** module chunks = 0
 **/